// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/Cards/UpdateCard/UpdateCard.css
// module id = 952
// module chunks = 0